import LoadingComponent from "../../../app/layout/LoadingComponent";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import axios from "axios";
import React, { useEffect, useState } from "react";

import Container from "react-bootstrap/Container";
import { Button } from "semantic-ui-react"
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import * as Yup from 'yup';
import "./AdminUsuarios_style.css"
import { Image } from "semantic-ui-react";

import "../../PerfilInstitucional/src/pInstitucional.css";

import { useStore } from "../../../app/stores/store";
import { CambiarCorreoyContraseñaFormValues, RecuperarUsuarioFormValues } from "../../../app/models/RecuperarUsuario";
import loginPlaceholder from '../../../../src/images/docente-placeholder.png';
import MyTextInput from "../../../app/common/form/MyTextInput";
import { Formik, Form } from "formik";
import SGPersonaFormBasico from "../../../features/SGPersonas/form/SGPersonaFormBasico";
import AllCollapseExample from "./CursosList";
// import { myBreadCrumbsConvRaiz } from './Handlers/BreadCrumbsConv';

var activeC: string = "Gestión de Códigos Institucionales"
interface Props{
    id_usuario : string;
    nombre_completo: string
    cui: string
    foto: string
}

export default observer(function AdminUsuario(props:Props) {
    const { UsersListStore, RecuperarUsuarioStore, modalStore } = useStore();
    const [correo, setCorreo] = useState("")
    const [passwordShown, setPasswordShown] = useState(false);
    const [passwordConfirmaShown, setPasswordConfirmaShown] = useState(false);
    const lowercaseRegex = /(?=.*[a-z])/;
    const uppercaseRegex = /(?=.*[A-Z])/;
    const numericRegex = /(?=.*[1-9])/;
    const caracterRegex = /(?=.*[@$!%*#?&%-/])/;

    useEffect(() => {
        // * Primero busca el correo del usuario segun el dpi
        let solicitudDPI: RecuperarUsuarioFormValues = {
            cui: props.cui,
        }
        RecuperarUsuarioStore.RecuperarUsuarioDPI(solicitudDPI).then(() =>{
            setCorreo(RecuperarUsuarioStore.correoUser)
        })
    }, [])

    function handleFormSubmit1(credencialesIngresadas:any) {
        let newCorreoContraseña:CambiarCorreoyContraseñaFormValues = {
            email: credencialesIngresadas.correo,
            token: props.id_usuario,
            password: credencialesIngresadas.contra
        }
        UsersListStore.CambiarContraseñaCorreo(newCorreoContraseña)
    }

    const validationSchema1 = Yup.object({
        correo: Yup.string().required('Obligatorio'),
        contra: Yup.string()
            .min(8, "Se requieren al menos 8 caracteres, entre ellos, al menos una letra mayuscula, un número y un caracter especial")
            .matches(lowercaseRegex,
                "Debe incluir minusculas"
            )
            .matches(uppercaseRegex,
                "Debe incluir alguna mayuscula"
            )
            .matches(numericRegex,
                "Debe incluir algun numero"
            )
            .matches(caracterRegex,
                "Debe incluir algun caracter especial"
            )
            .required("La contraseña es obligatoria"),
            passwordConfirma: Yup.string().required("La confirmación es obligatoria")
            .oneOf([Yup.ref("contra")], "Las Contraseñas no coinciden"),
    })

    return ( 

        <Container fluid>
            <Row className="contenedor_modificar_usuario">
                <Col xs={7} className="contenedor_izq_modUsuario">
                    <Row>
                        <Container fluid className="datos_usuario">
                            <Row className="header_mod_usuario">
                                <Col xs={2}>
                                    <Image className="foto_mod_usuario" src={ props.foto || loginPlaceholder} size='tiny' circular />
                                </Col>
                                <Col className="text_header_mod_usuario">
                                    <span>Nombre completo:</span>
                                    <h1>{props.nombre_completo}</h1>
                                    <span className="header_correo">{correo}</span>
                                </Col>
                            </Row>
                            <Row className="header_mod_usuario">
                                <Formik validationSchema={validationSchema1}
                                    enableReinitialize
                                    initialValues={{correo: correo, contra: "", passwordConfirma:""}}
                                    onSubmit={values => {
                                        handleFormSubmit1(values)}
                                        }>
                                    {({ handleSubmit, isValid, isSubmitting,errors, dirty }) => (

                                        <Form onSubmit={handleSubmit} autoComplete='off' style={{display:"flex", flexDirection:"row"}}>
                                            <div className='login-form-content' style={{position:"relative", display:"flex", flexDirection:"row"}}>
                                                <MyTextInput className="input_cambiar_credenciales" name='correo' placeholder={"Cambiar usuario"} type="text" defaultValue={correo}/>
                                                <MyTextInput name='contra' className='input_cambiar_credenciales' placeholder='Contraseña' type="password" />
                                                <div>
                                                    <MyTextInput name='passwordConfirma' className="input_cambiar_credenciales" placeholder='Confirmar contraseña' type="password" />
                                                </div>
                                            </div>
                                                <Button
                                                    loading={UsersListStore.loading}
                                                    type='submit'
                                                    icon={"check"}
                                                    className="primary boton_cambiar_credenciales"
                                                />

                                        </Form>
                                    )}
                                </Formik>
                            </Row>
                        </Container>
                    </Row>
                    <Row>
                        <Container fluid className="datos_cuentas">
                            <div style={{display: "flex", flexDirection: "row", marginTop: "20px", alignItems:"center", color:"#3B5998"}}>
                                <h2>Cursos inscritos</h2>
                                <hr style={{border: "1px solid #3B5998", width: "90px", marginLeft: "6px" }}></hr>
                            </div>
                            <div className="accordion_cuentas">
                                <AllCollapseExample  idUsuario={props.id_usuario} />
                            </div>
                        </Container>
                    </Row>
                </Col>
                <Col xs={5} className="contenedor_der_modUsuario">
                    <SGPersonaFormBasico id_user={props.id_usuario} />
                </Col>
            </Row>
        </Container>
    );
})
